import React, { memo } from 'react';
import styled, { keyframes } from 'styled-components';
import Flower from './Flower';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const GardenContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 2rem;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 1600px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    justify-items: center;
    max-width: 100%;
  }
`;

// Use a stable grid item to maintain positions during updates
const GridItem = styled.div`
  /* Make sure this element maintains its dimensions */
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FlowerItem = styled.div`
  animation: ${fadeIn} 0.5s ease-out forwards;
  animation-delay: ${props => props.index * 0.05}s;
  opacity: 0;
  position: relative;
  
  /* Make sure this container doesn't block the tooltip hover effects */
  &:hover {
    z-index: 9000;
  }
`;

const Garden = ({ stocks }) => {
  const isSearchResult = stocks.length === 1;
  
  return (
    <GardenContainer>
      {stocks.map((stock, index) => (
        <FlowerItem key={stock.symbol} index={index}>
          <Flower 
            stock={stock} 
            isSearchResult={isSearchResult}
          />
        </FlowerItem>
      ))}
    </GardenContainer>
  );
};

// Use memo to prevent Garden from re-rendering unnecessarily
export default memo(Garden); 